import { tplLib } from '../../templateLib';
import SingleTplEntry from './index';

const routes = [
  {
    path: '/',
    component: SingleTplEntry
  }
];

export async function router(userType, code, tpl) {
  const tplModule = tplLib[tpl];
  if (!tplModule) {
    throw new Error(`模板不存在：${tpl}`);
  }
  if (tplModule.routes) {
    const tplRoutes = await tplModule.routes();
    if (tplRoutes && Array.isArray(tplRoutes)) {
      routes[0].children = tplRoutes;
    }
  }
  return routes;
}
